<template>
  <div class="image-uploader">
    <div class="col">
      <v-row v-if="imageUrl || imageData">
        <v-col class="pt-1 pb-1">
          <v-avatar color="#F5F5F5" :size="size" :tile="!isCircle">
            <img v-if="imageData" :src="imageData" class="img-show" />
            <img
              v-else-if="typeof imageUrl === 'string'"
              :srcset="
                imageUrl +
                '=c-w320, ' +
                imageUrl +
                '=c-w480 1.5x, ' +
                imageUrl +
                '=c-w640 2x'
              "
              :src="imageUrl + '=c-w640'"
            />
          </v-avatar>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          :class="imageUrl ? 'text-upload pt-2 pb-2' : 'text-upload pt-0 pb-2'"
          class="tw-text-black"
        >
          {{ description }}
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center pt-0 pb-1">
          <v-btn
            class="btn-upload"
            color="primary"
            @click="onClickUpload"
            :disabled="loading"
            >{{ buttonText }}</v-btn
          >
          <input
            v-show="false"
            ref="inputUpload"
            type="file"
            accept="image/*"
            @change="onFileChanged"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { checkImageSmall } from "../../../libs/validateImageUpload"

export default {
  props: {
    imageUrl: {
      type: String,
    },
    size: {
      type: Number,
      default: 60,
    },
    isCircle: {
      type: Boolean,
      default: true,
    },
    description: {
      type: String,
      default: 'อัปโหลดภาพ'
    },
    buttonText: {
      type: String,
      default: 'เลือกภาพ'
    },
    loading: {
      type: Boolean,
      default: false,
    },
    minWidth: {
      type: Number,
      default: 640,
    },
  },
  data: () => ({
    imageData: '',
    imageBlob: null,
  }),
  methods: {
    onClickUpload() {
      this.$refs.inputUpload.click()
    },
    onFileChanged(event) {
      if (event) {
        checkImageSmall(event.target.files[0], this.minWidth).then((imageSmall) => {
          if (imageSmall) {
            alert(`Image is too small. Please select an image with at least ${this.minWidth}px width`)
          } else {
            this.$emit('imageBlobUpdate', event.target.files[0])
            this.imageData = URL.createObjectURL(event.target.files[0])
          }
        })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.image-uploader {
  background: #f2f2f2;
  border: 1px dashed #707070;
  box-sizing: border-box;
  border-radius: 20px;
  min-height: 150px;
  display: flex;
  align-items: center;
  text-align: center;
}
</style>